import { XhrStatusResponse, postAction } from '../xhr';

const entityName = 'InterfazMercadoPago';

export interface IMPCompleteData {
  imp_id: string | null;
  imp_collection_id: string | null;
  imp_collection_status: string | null;
  imp_payment_id: string | null;
  imp_payment_status: string | null;
  imp_payment_type: string | null;
  imp_merchant_order_id: string | null;
  imp_preference_id: string | null;
  imp_site_id: string | null;
  imp_processing_mode: string | null;
  imp_merchant_account_id: string | null;
}

export const completeInterfaceData = async (d: IMPCompleteData) => {
  const res = await postAction<IMPCompleteData, any>(
    entityName,
    d
  );

  return res.data;
};
